import React, { useEffect, useState } from "react";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Stepper from "../Common/Stepper";
import showNotification from "../../services/redux/NotifcationService";
import { DetailsApi, stepTwoApiCall, stepTwoWithoutFileApiCall } from "../../services/redux/ApiActions";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import LogoDiv from "../Common/LogoDiv";
import logo from '../../img/BBPS_Horizontal.png'

export default function StepTwo() {
    const [sezFile, setSezFile] = useState(null);
    const [enableFile, setEnableFile] = useState(false);
    const [fileBytes, setFileBytes] = useState(null); // State to hold file bytes
    const customerData = useSelector((state) => state.customerData.customerData);
    const details = useSelector((state) => state.details.details);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const gstinResponse = JSON.parse(details?.result.gstinResponse);
    const panResponse = JSON.parse(details?.result.panResponse);
    const containsProprietor = details?.result.businessType.toLowerCase().includes("proprietor");
    const containsPerson = details?.result.businessType.toLowerCase().includes("person");
    const containsHindu = details?.result.businessType.toLowerCase().includes("hindu");
    const containsPartnership = details?.result.businessType.toLowerCase().includes("partnership");
    const doesntContainsLiability = !details?.result.businessType.toLowerCase().includes("liability");
    const [showLogo, setShowLogo] = useState(false)

    function handleFile(event) {
        const file = event.target.files[0];
        const extension = file.name.split('.').pop().toLowerCase();

        if (extension !== 'pdf') {
            showNotification('Only pdf file is allowed', 'error');
            // Optionally, clear the file input
            event.target.value = '';
        } else {
            setSezFile(file);
        }
    }
    const SkipStep = async () => {
        if (containsProprietor || containsPerson || containsHindu) {
            // Do something if any of the conditions are true
            navigate('/Customer/Step3Properitor');
        } else if (containsPartnership && doesntContainsLiability) {
            navigate('/Customer/Step3Partner');
        } else {
            navigate('/Customer/Step3Cin')
        }
    }
    const handleSubmit = async () => {
        const payload = new FormData();
        payload.append('SEZFile', sezFile);
        payload.append('fileName', sezFile?.name);
        if (enableFile !== false) {
            const data = await dispatch(stepTwoApiCall(payload, customerData?.token_chr, enableFile === true ? true : false, customerData?.custId));
            if (data !== null && data?.statusCode === 200) {
                await getDetails();
                showNotification('Success', 'success')
                if (containsProprietor || containsPerson || containsHindu) {
                    // Do something if any of the conditions are true
                    navigate('/Customer/Step3Properitor');
                } else if (containsPartnership && doesntContainsLiability) {
                    navigate('/Customer/Step3Partner');
                } else {
                    showNotification('Success', 'success')
                    await getDetails();
                    navigate('/Customer/Step3Cin')
                }
            }
        } else {
            try {
                const data = await dispatch(stepTwoWithoutFileApiCall(payload, customerData?.token_chr, customerData?.custId));
                if (data !== null && data?.statusCode === 200) {
                    // setDetails(data)
                    showNotification('Success', 'success')
                    await getDetails();
                    if (containsProprietor || containsPerson || containsHindu) {
                        // Do something if any of the conditions are true
                        navigate('/Customer/Step3Properitor');
                    } else if (containsPartnership && doesntContainsLiability) {
                        navigate('/Customer/Step3Partner');
                    } else {
                        // showNotification('Success', 'success')
                        await getDetails();
                        navigate('/Customer/Step3Cin')
                    }
                }
            } catch (error) {
                showNotification(error, 'error')
            }
        }
    }

    const getDetails = async () => {
        // console.log(userAgent)
        const Payload = {
            "id": customerData?.custId
        }
        // console.log(Payload)
        const data = await dispatch(DetailsApi(Payload, customerData?.token_chr, "customer"));
        dispatch(setDetailsData(data))
                if(data?.result?.programId === 34||data?.result?.programId === 35){
           setShowLogo(false)
        }else{
            setShowLogo(true)
        }
    }

    useEffect(() => {
 getDetails();
    }, [])
    
    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className="logoBG">
                    <div className="rightElement">
                        <CustomerHeader />
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <Stepper />
                                <div className='bg-white mx-2 shadow-xl p-6 mt-4 mb-4 rounded-lg'>
                                <div className="grid grid-cols-12 gap-4">
 <div className="col-span-12 md:col-span-2 lg:col-span-2">
</div>
 <div className="col-span-12 md:col-span-8 lg:col-span-8">
                                    <div className="py-2 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">GSTIN Details</h1>
                                    </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
{showLogo&&(
                                        <div style={{display:'flex',justifyContent:'right',marginTop:'-5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
)}
                                    </div>
 </div>
                                    <div className="py-2 text-center">
                                        <h1 className="text-sm text-gray-600">Please verify GSTIN & PAN details of your organisation
                                        </h1>
                                    </div>
                                    <div className='mt-2 border-none border-collapse rounded-md'>
                                        <table className=" w-full">
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">Trade Name : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{gstinResponse.TradeName}</td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">Legal Name : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{gstinResponse.LegalName}</td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">GSTIN : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{details?.result.gstin}</td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">Address : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{gstinResponse.FullAddress}</td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">Business Type : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{gstinResponse.BusinessType}</td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">GSTIN Status : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{gstinResponse.GSTINStatus}</td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">PAN : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{details?.result.pan}
                                                </td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">PAN Holder: </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{panResponse.lastName}

                                                </td>
                                            </tr>
                                            <tr className="border-b-2">
                                                <td className="w-full sm:w-1/4 p-2" align="left">
                                                    <label className="font-semibold">PAN Status : </label>
                                                </td>
                                                <td className="p-2 text-sm text-gray-800" align="left">{details?.result.panStatus}</td>
                                            </tr>
                                        </table>
                                        {/* <div className="my-4">
                                            <input
                                                type="checkbox"
                                                id="checkboxOption2"
                                                name="gstin"
                                                checked={enableFile}
                                                onChange={() => setEnableFile(!enableFile)}
                                                className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                                            />
                                            <label
                                                htmlFor="checkboxOption2"
                                                className="ml-2 text-black text-sm font-semibold"
                                            >
                                                Is Tax Payment Type is SEZ Unit
                                            </label>
                                        </div> */}
                                        {enableFile && (
                                            <div className="mt-4">
                                                <label className="text-gray-700 font-bold text-md">SEZ Declaration Certificate <label className="text-red-500 text-xs">(Only pdf file is allowed)</label></label>
                                                <br />
                                                <input
                                                    type="file"
                                                    className="mt-2"
                                                    accept="application/pdf" // Specify the accepted file types here
                                                    onChange={handleFile} // Handle file selection
                                                />
                                            </div>
                                        )}

                                        <div className="col-span-12 md:col-span-7 lg:col-span-7">
                                            <div className="relative text-center">
                                                <button onClick={handleSubmit} className="vtpRm-action-button">
                                                    {details?.result.lastCompletedStep > 2 ? 'Re-Verify & Proceed' : 'Verify & Proceed'}
                                                </button>
                                                {details?.result.lastCompletedStep > 2 ? <>
                                                    <span className="skip-btn hover:cursor-pointer py-4 px-4" onClick={SkipStep} >
                                                        Skip this step
                                                    </span>
                                                </> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </LogoDiv>
            </body>
        </>
    );
}